import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { OrderStatus } from '../enums';

@Injectable({
  providedIn: 'root',
})
export class OrderStatusProviderService {
  private readonly entries = new Map<OrderStatus, string>([
    [OrderStatus.Cancelled, 'Anulowane'],
    [OrderStatus.Completed, 'Zrealizowane'],
    [OrderStatus.New, 'Nowe'],
    [OrderStatus.Paid, 'Opłacone'],
    [OrderStatus.PartiallyCompleted, 'Częściowo zatwierdzone'],
    [OrderStatus.Pending, 'W trakcie realizacji'],
    [OrderStatus.Refunded, 'Zwrócone'],
    [OrderStatus.PartiallyRefunded, 'Częściowo zwrócone'],
    [OrderStatus.WaitingForPayment, 'Oczekiwanie na płatność'],
  ]);

  public labelFor(status: OrderStatus): Observable<string> {
    const result = this.entries.get(status);

    if (isNil(result)) {
      throw new EntryNotFoundException(
        `The entry for "${status}" is not found.`,
      );
    }

    return of(result);
  }

  public selectItems(): Observable<SelectItem<OrderStatus>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([type, label]) => new SelectItem<OrderStatus>(label, type),
      ),
    );
  }
}
